<template>
	<div class="Index" v-loading="loadingEfect">
		<div class="case-pice" style="clear: both;">
			<span class="case-pice-first">会员单位管理</span> 
			<span class="case-pice-and">/</span> 
			<span class="case-pice-second">首页</span>
			<el-button size='small' type="primary" style="font-size: 14px;float: right;" @click='exportTable()' plain>批量导出企业照片</el-button>
		</div>
		<div style="clear: both;">
			<div class="commom-input-label">会员单位名称：</div>
			<el-input v-model="searchData.companyName" clearable class='common-input-width' size='small' placeholder="请输入会员单位名称"></el-input>
			<div class="commom-input-label" style="margin-left: 20px;">统一社会代码：</div>
			<el-input v-model="searchData.creditCode" clearable class='common-input-width' size='small' placeholder="请输入统一社会代码"></el-input>
			<div class="commom-input-label" style="margin-left: 20px;width: 50px;">地区：</div>
			<el-cascader style="common-input-width" clearable size='small' @change="changegeData(bigName)" placeholder="请选择地区" v-model="bigName" :options="mapData" :props="{value:'label'}">
			</el-cascader>
			<el-button size='small' type="primary" style="margin-left: 10px;font-size: 14px;" @click='search()' plain icon="el-icon-search">查询</el-button>
			<el-button size='small' type="primary" style="margin-left: 10px;font-size: 14px;float: right;margin-top: 15px;" @click='goMemberInfo("add")' plain icon="el-icon-circle-plus-outline">添加单位</el-button>
			
		</div>
		<el-table :data="tableData" border style="width: 100%" stripe height=' calc(100vh - 220px)'  @selection-change="handleSelectionChange" :row-key="getRowKeys">
			<el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
			<el-table-column label="序号" width="60">
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column prop="companyName" min-width="200" show-overflow-tooltip label="会员单位名称">
			</el-table-column>
			<el-table-column show-overflow-tooltip min-width="200" label="企业所属县区">
				<template slot-scope="scope">
					{{scope.row.provinceName}} - {{scope.row.cityName}} - {{scope.row.countyName}}
				</template>
			</el-table-column>
			<el-table-column prop="businessAddress" min-width="200"  show-overflow-tooltip label="营业执照地址">
			</el-table-column>
			<el-table-column prop="companySource" min-width="100"  show-overflow-tooltip label="来源">
				<template slot-scope="scope">
					<span v-if="scope.row.companySource == 1">学员申请</span>
					<span v-else>系统注册</span>
				</template>
			</el-table-column>
			<el-table-column  min-width="160"  prop="creditCode" show-overflow-tooltip label="统一社会代码">
			</el-table-column>
			<el-table-column prop="corp" min-width="100"  show-overflow-tooltip label="法人">
			</el-table-column>
			<el-table-column prop="updateTime"  min-width="160"  show-overflow-tooltip label="更新时间">
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="230">
				<template slot-scope="scope">
					<el-button size='mini' type="primary" @click='goMemberInfo("update",scope.row)' plain>编辑</el-button>
					<el-button size='mini' type="danger" @click='deleteMember(scope.row)' plain>删除</el-button>
					<el-button size='mini' type="info" @click='goMemberInfo("look",scope.row)' plain>查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-block">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
  companyList,
  deleteCompany,
  getDetailCompany,
  addCompany
} from "../../api/main";
import map from "@/common/js/map.js";
import axios from 'axios'
export default {
  name: "Index",
  mounted() {
    this.getCompanyList();
  },
  activated() {
    this.getCompanyList();
  },
  data() {
    return {
      mapData: map,
      searchData: {
        companyName: "",
        creditCode: ""
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalNumber: 0,
      nowSelectDataList: [],
      loadingEfect: false,
      provinceName: "",
      cityName: "",
      countyName: "",
      bigName: ""
    };
  },
  methods: {
    changegeData(value) {
      console.log(value);
      if (value.length == 2) {
        this.provinceName = value[0];
        this.cityName = value[0];
        this.countyName = value[1];
      } else {
        this.provinceName = value[0];
        this.cityName = value[1];
        this.countyName = value[2];
      }
    },
    getRowKeys(row) {
      return row.companyId;
    },
    search() {
      this.currentPage = 1;
      this.getCompanyList();
    },
    handleSizeChange(data) {
      this.pageSize = data;
      this.getCompanyList();
    },
    handleCurrentChange(data) {
      this.currentPage = data;
      this.getCompanyList();
    },
    addMember() {},
    getCompanyList() {
      companyList({
        companyName: this.searchData.companyName,
        creditCode: this.searchData.creditCode,
        current: this.currentPage,
        pageSize: this.pageSize,
        provinceName: this.provinceName,
        cityName: this.cityName,
        countyName: this.countyName
      }).then(res => {
        this.totalNumber = parseInt(res.data.total);
        this.tableData = res.data.records;
      });
    },
    goMemberInfo(pageType, row) {
      this.$store.state.memberPageType = pageType;
      if (pageType == "update") {
        this.$store.state.memberPageId = row.companyId.toString();
        this.$router.push("/MemberInfoPage");
      }
      if (pageType == "add") {
        this.$router.push("/MemberInfoPage");
      }
      if (pageType == "look") {
        this.$store.state.memberPageId = row.companyId.toString();
        this.$router.push("/LookCompany");
      }
    },
    deleteMember(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteCompany(row.companyId).then(res => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSelectionChange(data) {
      this.nowSelectDataList = data;
    },
    exportTable() {
      if (this.nowSelectDataList.length == 0) {
        this.$message.error("请选择您想要导出的单位数据");
        return;
      }
      let arrList = [];
      this.loadingEfect = true;
      this.nowSelectDataList.forEach(item => {
        arrList.push(item.companyId);
      });
      axios({
        // responseType: "blob",
        url: `${this.$httpUrl}/admin/download/company/imgs`,
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        data: arrList
      }).then(res => {
			if(res.data.code == '1'){
						window.open(res.data.data)
						this.$message.success('导出成功！')
						this.loadingEfect = false;
					}else{
						this.$message.error('导出失败，请重试！')
						this.loadingEfect = false;
					}
        // console.log(res);
        // const link = document.createElement("a");
        // let blob = new Blob([res.data], {
        //   type: "application/vnd.ms-excel"
        // });
        // link.style.display = "none";
        // link.href = URL.createObjectURL(blob);
        // link.setAttribute("download", "学员信息列表.xlsx");
        // document.body.appendChild(link);
        // link.click();
        // URL.revokeObjectURL(link.href);
        // document.body.removeChild(link);
        // this.loadingEfect = false;
        // this.$message.success("导出成功！");
      });
    }
  }
};
</script>
<style lang='less'>
.el-table {
}
</style>